export const tags = [
  "jnct-ongoing-courses",
  "jnct-catalog-courses",
  "jnct-archived-courses",
  "jnct-manage-course",
  "jnct-manage-course-activity-settings",
  "jnct-calendar-section-reveal",
  "jnct-manage-students",
  "jnct-lms-settings",
  "jnct-lms-label-modal",
  "jnct-lms-mapping-modal",
  "jnct-student-courses",
  "student-course-card",
  "course-enroll-modal",
] as const;
